import { Directive, ElementRef, Renderer2, HostListener, Input } from '@angular/core';

@Directive({
    selector: 'input[type=password]',
})
export class TogglePasswordDirective {
    @Input() showIcon: string = 'fa-eye';
    @Input() hideIcon: string = 'fa-eye-slash';

    private isPasswordVisible: boolean = false;
    private button: HTMLElement;

    constructor(private el: ElementRef, private renderer: Renderer2) {
        this.createToggleButton();
    }

    private createToggleButton(): void {
        this.button = this.renderer.createElement('button');
        this.renderer.setAttribute(this.button, 'type', 'button');
        this.renderer.addClass(this.button, 'toggle-password-btn');
        this.renderer.listen(this.button, 'click', () => this.togglePasswordVisibility());

        const icon = this.renderer.createElement('i');
        this.renderer.addClass(icon, 'fa');
        this.renderer.addClass(icon, this.showIcon);
        this.renderer.addClass(this.button, 'btn')
        this.renderer.appendChild(this.button, icon);
        this.renderer.setAttribute(this.button, 'aria-label', 'Activar o desactivar la visibilidad de la contraseña');

        const parent = this.el.nativeElement.parentNode;
        this.renderer.setStyle(parent, 'position', 'relative');
        this.renderer.setStyle(this.el.nativeElement, 'padding-right', '50px');
        this.renderer.setStyle(this.button, 'position', 'absolute');
        this.renderer.setStyle(this.button, 'right', '10px');
        this.renderer.setStyle(this.button, 'top', '46px');
        this.renderer.setStyle(this.button, 'transform', 'translateY(-50%)');
        this.renderer.setStyle(this.button, 'background', 'none');
        this.renderer.setStyle(this.button, 'border', 'none');
        this.renderer.setStyle(this.button, 'cursor', 'pointer');
        this.renderer.appendChild(parent, this.button);
    }

    private togglePasswordVisibility(): void {
        this.isPasswordVisible = !this.isPasswordVisible;
        const inputType = this.isPasswordVisible ? 'text' : 'password';
        this.renderer.setAttribute(this.el.nativeElement, 'type', inputType);

        const icon = this.button.querySelector('i');
        this.renderer.removeClass(icon, this.isPasswordVisible ? this.showIcon : this.hideIcon);
        this.renderer.addClass(icon, this.isPasswordVisible ? this.hideIcon : this.showIcon);
    }
}
